import React, { Component } from 'react';
import { connect }          from 'react-redux';
import PageContent          from './../PageContent';
import LoadingSvg           from './../../components/LoadingSvg';
import _                    from 'lodash'
import PropTypes            from 'prop-types';

class PageContentContainer extends Component
{

    findPage = () =>
    {
        let pages              = this.props.pages.data;
        let { keyName, value } = this.props;
        return _.find(pages, (page) => {
            return (page[keyName] === value);
        });
    };

    render = () => 
    {
        if (false === this.props.pages.fetched)
        {
            return <LoadingSvg/>
        }
        else
        {
            return (
                <PageContent
                    page={ this.findPage() }
                />
            );
        }
    }

}

const mapStateToProps = (state) =>
{
    return {
        pages: state.pages
    };
};

PageContentContainer = connect(mapStateToProps)(PageContentContainer);

PageContentContainer.props = {
    key: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default PageContentContainer;


// WEBPACK FOOTER //
// ./src/components/containers/PageContentContainer.js